import ApiClient from "@/api/v2/base";
import route from "@/bundles/route";

class SettingsPaymentsApi extends ApiClient {
    getBalance() {
        const url = route("api.v2.payments.balance");
        return this.getAuthenticated(url);
    }

    getPaymentMethods() {
        const url = route("api.v2.payments.methods");
        return this.getAuthenticated(url);
    }
}

export default SettingsPaymentsApi;
